import { create } from 'zustand';

export interface UploadImageStore {
  isUploading: boolean;
  setIsUploading: (isUploading: boolean) => void;
}

export const useUploadImageStore = create<UploadImageStore>()(set => ({
  isUploading: false,

  setIsUploading: isUploading => set({ isUploading }),
}));
